/* eslint no-unused-vars: 0 */
import $ from "jquery";

import initCookiePopup from "./cookie-popup";
import initScrollTo from "./scroll-to";
import Accordion from "./accordion";
import AnimateBackground from "./animateBackground";
import Counter from "./counter";
import HeadingsAnim from "./headingsAnim";
import heroAnimations from "./heroAnimations";
import menuIcon from "./menu-icon";
import mobileMenu from "./mobile-menu";
import SwipeSlider from "./swiper";
import sideMenu from "./sidemenu";
import interpolateBackground from "./interpolation";
import weAreCoworkersTop from "./weAreCoworkersTop";
import weAreCoworkersBottom from "./weAreCoworkersBottom";
import areaSwiper from "./area-swiper";
import Search from "./search";
import BusinessAreaVideo from "./businessAreaVideo";
import ImageSlider from "./imageSlider";
import MovePaginationNext from "./movePaginationNext";
import filterAjax from "./filter-ajax";
import SearchFocus from "./searchFocus";
import SelectFilter from "./select-filter";
import initRestartContactGallery from "./restartContactGallery";
import ContactAutoSuggest from "./contactAutoSuggest";
import relatedSingles from "./relatedSingles";
import ActiveStateForMenu from "./activeStateForMenu";
import BreadcrumbOverride from "./breadcrumbOverride";

$(function () {
    const $cookiePopup = $(".js-cookie-popup");
    if ($cookiePopup.length) {
        $cookiePopup.map((i, v) => initCookiePopup(v));
    }

    const $jsScrollTo = $(".js-scroll-to");
    if ($jsScrollTo.length) {
        $jsScrollTo.map((i, v) => initScrollTo(v));
    }

    const $jsMobileMenu = $(".js-toggle-menu");
    if ($jsMobileMenu.length) {
        $jsMobileMenu.map((i, v) => mobileMenu(v));
    }

    const $jsSearch = $(".js-open-search");
    if ($jsSearch.length) {
        $jsSearch.map((i, v) => Search(v));
    }

    const $jsMenuIcon = $(".js-icon-item");
    if ($jsMenuIcon.length) {
        $jsMenuIcon.map((i, v) => menuIcon(v));
    }

    const $jsSideMenu = $(".js-toggle-sidemenu");
    if ($jsSideMenu.length) {
        $jsSideMenu.map((i, v) => sideMenu(v));
    }

    const $jsSwiper = $(".js-swiper");
    if ($jsSwiper.length) {
        $jsSwiper.map((i, v) => SwipeSlider(v));
    }

    const $areaSwiper = $(".js-area-card-swiper");
    if ($areaSwiper.length) {
        $areaSwiper.map((i, v) => areaSwiper(v));
    }

    const $businessAreaVideo = $(".js-business-video");
    if ($businessAreaVideo.length) {
        $businessAreaVideo.map((i, v) => BusinessAreaVideo(v));
    }

    const $weAreCoworkersTop = $(".we_are_coworkers_top");
    if ($weAreCoworkersTop.length) {
        $weAreCoworkersTop.map((i, v) => weAreCoworkersTop(v));
    }

    const $weAreCoworkersBottom = $(".we_are_coworkers_bottom");
    if ($weAreCoworkersBottom.length) {
        $weAreCoworkersBottom.map((i, v) => weAreCoworkersBottom(v));
    }

    const $jsCounter = $(".js-counter");
    if ($jsCounter.length) {
        $jsCounter.map((i, v) => Counter(v));
    }

    const $imageSlider = $(".js-image-slider");
    if ($imageSlider.length) {
        $imageSlider.map((i, v) => ImageSlider(v));
    }

    const $jsAccordion = $(".js-accordion-button");
    if ($jsAccordion.length) {
        $jsAccordion.map((i, v) => Accordion(v));
    }

    const $jsHeadingsAnim = $("h1, h2, h3, h4, h5, h6, .hero-title_animation");
    if ($jsHeadingsAnim.length) {
        $jsHeadingsAnim.map((i, v) => HeadingsAnim(v));
    }

    const $jsAnimateBackground = $(".js-animate-background");
    if ($jsAnimateBackground.length) {
        $jsAnimateBackground.map((i, v) => AnimateBackground(v));
    }

    const $jsHeroAnimations = $(".js-animate-hero");
    if ($jsHeroAnimations.length) {
        $jsHeroAnimations.map((i, v) => heroAnimations(v));
    }

    const $interpolateBackground = $(".hero");
    if ($interpolateBackground.length) {
        $interpolateBackground.map((i, v) => interpolateBackground(v));
    }

    const $movePaginationNext = $(".pagination__list");
    if ($movePaginationNext.length) {
        $movePaginationNext.map((i, v) => MovePaginationNext(v));
    }

    const $filterAjax = $(".js-filter-ajax");
    if ($filterAjax.length) {
        $filterAjax.map((i, v) => filterAjax(v));
    }

    const $searchFocus = $(".js-menu-main__input");
    if ($searchFocus.length) {
        $searchFocus.map((i, v) => SearchFocus(v));
    }

    const $selectFilter = $(".js-archive-filter");
    if ($selectFilter.length) {
        $selectFilter.map((i, v) => SelectFilter(v));
    }

    const $galleryImagesRestart = $(".contact__building");
    if ($galleryImagesRestart.length) {
        $galleryImagesRestart.map((i, v) => initRestartContactGallery(v));
    }

    const $contactAutoSuggest = $(".js-contact-autosuggest");
    if ($contactAutoSuggest.length) {
        $contactAutoSuggest.map((i, v) => ContactAutoSuggest(v));
    }

    const $relatedSingles = $(".js-related-singles");
    if ($relatedSingles.length) {
        $relatedSingles.map((i, v) => relatedSingles(v));
    }

    const $activeStateForMenu = $(".menu-main__item");
    if ($activeStateForMenu.length) {
        $activeStateForMenu.map((i, v) => ActiveStateForMenu(v, "navbar"));
    }

    const $activeStateForHeaderMenu = $(".header-menu__large-link");
    if ($activeStateForHeaderMenu.length) {
        $activeStateForHeaderMenu.map((i, v) =>
            ActiveStateForMenu(v, "header")
        );
    }

    const $breadcrumbOverride = $(".breadcrumbs__link");
    if ($breadcrumbOverride.length) {
        $breadcrumbOverride.each(function () {
            BreadcrumbOverride(this);
        });
    }
});
